import { Link } from 'ui/navigation/Link'
import { Box, FlexBox } from 'ui/primitives'
import { RichText } from 'components/vendor/Contentful/richText/RichTextRenderer'
import { Document } from '@contentful/rich-text-types'
import { Heading } from 'ui/typography'

interface Props {
	icon: React.ReactNode
	title: string
	link?: { href: string; text: string }
	richTextValue?: Document
}

export const AsideItem = ({ icon, title, link, richTextValue }: Props) => {
	return (
		<FlexBox gap="lg">
			<FlexBox shrink={0}>{icon}</FlexBox>
			<Box>
				<Heading.H4>{title}</Heading.H4>
				{link && <Link href={link.href}>{link.text}</Link>}
				{richTextValue && <RichText document={richTextValue} />}
			</Box>
		</FlexBox>
	)
}
